"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _selectNext = _interopRequireDefault(require("./select-next"));

var enterHandler = function enterHandler(e, formOptions, activeStep, findCurrentStep, handleNext, handleSubmit) {
  if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey) {
    var isNotButton = e.target.type !== 'button';

    if (isNotButton) {
      e.preventDefault();
      var schemaNextStep = findCurrentStep(activeStep).nextStep;
      var hasCustomButtons = findCurrentStep(activeStep).buttons;
      var nextStep;

      if (schemaNextStep) {
        nextStep = (0, _selectNext["default"])(schemaNextStep, formOptions.getState);
      }

      var canContinue = formOptions.valid && !formOptions.getState().validating;

      if (canContinue && nextStep && !hasCustomButtons) {
        handleNext(nextStep, formOptions.getRegisteredFields);
      } else if (canContinue && !schemaNextStep && !hasCustomButtons) {
        handleSubmit();
      }
    }
  }
};

var _default = enterHandler;
exports["default"] = _default;